const ERROR_TRANSLATIONS: Record<string, string> = {
  'The requested qty is not available': 'Cantitatea nu este disponibila',
  'The requested qty exceeds the maximum qty allowed in shopping cart':
    'Cantitatea solicitata depaseste cantitatea maxima permisa in cosul de cumparaturi',
  'Product that you are trying to add is not available.':
    'Produsul pe care incerci sa il adaugi nu are cantitatea disponibila.',
}

function getErrorMessage(message: string): string {
  return ERROR_TRANSLATIONS[message] ?? ''
}

interface TranslateProps {
  message: string
}

export function Translate({ message }: TranslateProps) {
  return (
    <div className="text-red-500 text-sm mt-3 xl:mt-0">
      {getErrorMessage(message)}
    </div>
  )
}
